import { actions } from '@grandvisionhq/state';

const updateActiveVariant = actions.action('UPDATE_ACTIVE_VARIANT', actions.payload());
const updatePurchaseType = actions.action('UPDATE_PURCHASE_TYPE', actions.payload());

export { updateActiveVariant, updatePurchaseType };
//# sourceMappingURL=actions.js.map
